module.exports = __webpack_public_path__ + "media/application/images/ui/logo-7d27cad0dc692cdc0b9154460e9decc1.png";